import React from "react";
import NotificationStatusPanel from "../../../components/Notification/NotificationsStatus";

const TaskStatusPanel: React.FC = () => <NotificationStatusPanel />;
export default TaskStatusPanel;